import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {getUnSubscribeApiData} from 'src/utils/content-subscription';
import {
  saveUserSubscriptionApi,
  getUserContentSubscriptionsExternal,
} from 'src/action-creators/content-subscription';

import {selectUserContentSubscriptionExternal} from 'src/selectors/content-subscription';

import UnsubscribeComponent from 'src/components/content-subscription/manage/unsubscribe-content-category';


const Unsubscribe = ({
  params: {
    unsubscribeCategoryId,
    attributeName,
    attributeValue,
    entityId,
    entityType,
    sentEventId,
    isDebugEntity,
  },
}: {
  params: {
    sentEventId: string;
    unsubscribeCategoryId: string;
    attributeValue: string;
    attributeName: string;
    entityId: string;
    entityType: string;
    deliveryAddress: string;
    isDebugEntity: boolean;
  };
}) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = React.useState(false);
  const [alreadyUnsubscribed, setAlreadyUnsubscribed] = React.useState(false);

  const category = useSelector((state) => {
    const userSubscriptions = selectUserContentSubscriptionExternal(
      state,
      entityId,
    );
    if (userSubscriptions) {
      return userSubscriptions.find(
        (sub) =>
          sub.content_subscription_category_id ===
          Number(unsubscribeCategoryId),
      );
    }

    return null;
  });

  React.useEffect(() => {
    if (!isDebugEntity && attributeName) {
      dispatch(
        getUserContentSubscriptionsExternal(
          entityType,
          entityId,
          attributeName,
        ),
      );
    }
  }, [attributeName]);

  React.useEffect(() => {
    if (category && category.subscription[0]?.is_subscribed === false) {
      setAlreadyUnsubscribed(true);
    }
  }, [category]);

  const onUnsubscribe = async () => {
    const apiData = getUnSubscribeApiData(
      Number(unsubscribeCategoryId),
      attributeName,
      attributeValue,
      sentEventId,
    );
    try {
      await dispatch(
        saveUserSubscriptionApi(entityType, entityId, apiData, true),
      );
      setSuccess(true);
    } catch (e: any) {}
  };

  return (
    <UnsubscribeComponent
      success={success}
      isDebugEntity={isDebugEntity}
      // @ts-expect-error - TS2322 - Type 'UserContentSubscription | null | undefined' is not assignable to type 'UserContentSubscription'.
      category={category}
      alreadyUnsubscribed={alreadyUnsubscribed}
      onUnsubscribe={onUnsubscribe}
      redirectLink={`/content-subscription/manage/${sentEventId}?attribute_name=${attributeName}&attribute_value=${attributeValue}`}
    />
  );
};

export default Unsubscribe;
